import { Redirect, Route } from "react-router";



export const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  const token = sessionStorage.getItem("token");
  const userRole = sessionStorage.getItem("role");
  const firstAccess = sessionStorage.getItem("firstAccess"); // string "1" or "0"

  return (
    <Route
      {...rest}
      render={(props) => {
        // 1) não autenticado
        if (!token) {
          return (
            <Redirect
              to={{
                pathname: "/master/login",
                state: { from: props.location },
              }}
            />
          );
        }

        // 2) primeiro acesso: só permite change-password
        // ajuste o pathname caso sua rota seja diferente ("/change-password")
        if (firstAccess === "1" && props.location.pathname !== "/change-password") {
          return <Redirect to="/change-password" />;
        }

        // 3) se rota exige roles e usuário não tem permissão
        if (roles && !roles.includes(Number(userRole))) {
          return <Redirect to="/home" />;
        }

        // 4) permite acessar
        return <Component {...props} />;
      }}
    />
  );
};

